import Controls from './controls.container';

export default Controls;
